import { ExclamationIcon } from '@heroicons/react/outline';
import { Button, Modal } from '@yoast/ui-library';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title: string;
  disabled?: boolean;
  description: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  className?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title,
  description,
  disabled = false,
  confirmText = 'Yes, delete',
  cancelText = 'No, go back',
  className,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      position="center"
      as="div"
      className={className}
    >
      <Modal.Panel>
        <div className="yst-flex yst-items-start yst-justify-stretch yst-gap-4">
          <div>
            <span className="yst-inline-flex yst-h-10 yst-w-10 yst-items-center yst-justify-center yst-rounded-full yst-bg-red-100">
              <ExclamationIcon className="yst-h-6 yst-w-6 yst-text-red-600" />
            </span>
          </div>
          <div className="yst-flex-1">
            <Modal.Container.Header className="yst-mb-3 yst-w-full">
              <Modal.Title as="h3" className="yst-text-lg yst-font-medium">
                {title}
              </Modal.Title>
            </Modal.Container.Header>
            <Modal.Container.Content className="yst-mb-4 yst-space-y-3">
              {typeof description === 'string' ? (
                <p>{description}</p>
              ) : (
                description
              )}
            </Modal.Container.Content>
          </div>
        </div>
        <Modal.Container.Footer className="yst-mt-3 yst-flex yst-justify-end yst-gap-2">
          <Button variant="secondary" onClick={onClose}>
            {cancelText}
          </Button>
          <Button
            variant="error"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={disabled}
          >
            {confirmText}
          </Button>
        </Modal.Container.Footer>
      </Modal.Panel>
    </Modal>
  );
};

export default DeleteConfirmationModal;
